import * as types from "../constants/actionsTypes";

const initialState = {
  dataOfChanging: null,
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_CHANGING_REQUEST:
      return {
        ...state,
        loading: true,
        dataOfChanging: []
      };
    case types.LOAD_CHANGING_SUCCESS:
      return {
        ...state,
        loading: false,
        dataOfChanging: action.data
      };
    case types.LOAD_CHANGING_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/changing.js